// 'use client'

/***
 *
 * @file components/Footer/index.tsx
 * @description Footer component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React from "react";
// import "./Footer.scss";
import RenderHtml from "@/shared/RenderHtml";
import classNames from "classnames";
import { useResponsive } from "@/client/hooks/useResponsive";

type T_Props = {
  data?: any
}

/**
 * Name: Footer
 * 
 * Description: It renders the footer component for a page
 * 
 * @example T_Props 
 * ```
 * type T_Props = {
 *     data?: any,         // optional
 * }
 * ```
 * 
 * @returns a footer component with children links/ content rendered as a part of it
 */

export interface FooterProps {
  "data-test-id"?: string;
  /**
   * The Footer className.
   * @type {string}
   */
  className?: string;
  /**
   * The Footer data.
   * @type {string}
   */
  data?: any;
  /**
   * Footer nested children
   * @type {any}
   */
  children? : any;

  /**
   * Studio integration properties
   */
  image?: string;
  copyrightText?: string;
  privacyLabel?: string;
  privacyUrl?: string;
  cookieSettingsLabel?: string;
  cookiePrivacyPolicyUrl?: string;
  cookiePrivacyPolicyLabel?: string;
  /**
   * Studio/ Renderer reference flag.
   * @type boolean;
   */
}


const Footer = (props: FooterProps) => {
  const { isMd } = useResponsive();
  let footerData: any = {};

  const imagePlaceholder = props.image ? (props.image + '?fit=fill&f=center') : 'https://placehold.co/146x28';

  const getData = (data: any) => {
    let newData = data || {};

    return newData;
  };

  const elData = props?.data; 

  if (props.data && Object.keys(props.data).length > 0) {
    footerData = {
      copyrightText: props?.data?.items?.[0]?.content?.copyRightText?.content?.[0]?.content?.[0]?.value,
      image: props?.data?.items?.[0]?.content?.links?.[0]?.content?.logo?.content?.file?.url,
      privacyLabel: props?.data?.items?.[0]?.content?.links?.[0]?.content?.pages?.[0]?.content?.linkText,
      privacyUrl: props?.data?.items?.[0]?.content?.links?.[0]?.content?.pages?.[0]?.content?.slug,
      cookieSettingsLabel: props?.data?.items?.[0]?.content?.links?.[0]?.content?.pages?.[1]?.content?.linkText,
      cookiePrivacyPolicyUrl: props?.data?.items?.[0]?.content?.links?.[0]?.content?.pages?.[1]?.content?.slug
    }
  } else {
    footerData = { ...props };
  }

  return (
    <div 
      className={classNames("w-screen m-auto flex items-center", "baseplateFooter", "text-footer-nav-link-text bg-footer-nav-link-bg", props?.className || "")} data-testid="Footer">
      {props?.children ? (props?.children) : (<RenderHtml data={elData} rendererIndex={0} />)}
    </div>
    // <div {...inspectorModeProps({fieldId: elData?.contentType || "baseplateFooter", entryId: elData?.id})} className="Footer" data-testid="Footer">
    //   {/* <pre>{JSON.stringify(elData, null, 2)}</pre> */}
    //   {/* <RenderHtml data={elData} rendererIndex={0} /> */}
    // </div>
  );
};

export default Footer;
